// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { __ } from '../../../../i18n/l10n';
import { setPublicGridFilter as setPublicGridFilterAction } from '../../actions/public';
import GridsFilters from '../../components/buttons/GridsFilters';
import { PublicGridFilters } from '../../types';

const legacySelector = memoize((state) => {
  const filters = [
    {
      id: PublicGridFilters.MOST_COMPLETE,
      label: __('Most advanced'),
    },
    {
      id: PublicGridFilters.MOST_EXPENSIVE,
      label: __('Most expensive'),
    },
    {
      id: PublicGridFilters.LESS_EXPENSIVE,
      label: __('Least expensive'),
    },
    {
      id: PublicGridFilters.MOST_POPULAR,
      label: __('Most popular'),
    },
    {
      id: PublicGridFilters.MOST_RECENT,
      label: __('Most recent'),
    },
    {
      id: PublicGridFilters.BEST_AUTHOR_WINNINGS,
      label: __('Best author (winnings)'),
    },
    {
      id: PublicGridFilters.BEST_AUTHOR_BADGES,
      label: __('Best author (badge)'),
    },
  ];
  return {
    filters,
    currentFilterId: state.grids.publicGrids.filter,
  };
});

type GridsPublicFiltersContainerProps = {
  className?: string;
};

const GridsPublicFiltersContainer = (ownProps: GridsPublicFiltersContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(legacySelector);

  const setFilter = useCallback(
    (filterId) => {
      dispatch(setPublicGridFilterAction(filterId));
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      setFilter,
    }),
    [setFilter],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsFilters {...enhancedProps} />;
};

export default GridsPublicFiltersContainer;
